import module from 'cheques/module.js'
import template from './template.html'

class ChequesListadoListaComponent {
  constructor (ChequesEmpresasCuentaBancariaCheques, $filter) {
    this.ChequesEmpresasCuentaBancariaCheques = ChequesEmpresasCuentaBancariaCheques
    this.busqueda = null
    this.filterBy = $filter('filter')
    this.seleccionado = null
    this.results = undefined
    this.filtro = {
      general: '',
      total: '',
      cheque: '',
    }
  }

  $onInit () {
    this.$promise = this.ChequesEmpresasCuentaBancariaCheques.get(this.busqueda)
      .then((resolve) => (this.data = resolve.data))
      .then(() => (this.filtrar()))
  }

  filtrar () {
    let results = this.data

    if (this.filtro.general) {
      results = this.filterBy(results, this.filtro.general)
    }

    if (this.filtro.cheque) {
      results = this.filterBy(results, {
        cheque: this.filtro.cheque,
      })
    }

    if (this.filtro.importe) {
      results = this.filterBy(results, {
        importe: this.filtro.importe,
      })
    }

    this.results = results
  }

  editar (item, data) {
    this.results.splice(this.results.indexOf(item), 1, data)
    this.seleccionado = null
  }
}

module.component('chequesListadoLista', {
  controller: ChequesListadoListaComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cheques/components/listado/lista/component.js